import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from '../util/spinner.module.css'

import { makeStyles, createStyles } from '@material-ui/core/styles';


// HOURGLASS
//
export function Hourglass({ color, size, className, style, margin }) {
  //console.log("Hourglass.7: className=", classNames(styles['lds-hourglass'], className));
  //console.log("Hourglass.11: styles=", styles);
  return (
    <div className={classNames(styles['lds-hourglass'], className)} style={{ ...style }}>
      <div
        className={classNames(styles['lds-hourglass-after'])}
        style={{ background: color, borderWidth: size, borderHeight: size, margin: margin }}
      ></div>
    </div>
  )
}
Hourglass.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
  size: PropTypes.number, /** size in pixel */
  margin: PropTypes.number, /** size in pixel */
}
Hourglass.defaultProps = {
  color: '#7f58af',
  className: '',
  size: 32,
  margin: 0,
  style: {},
}



// ELLIPSIS
//
export function Ellipsis({ color, size, className, style }) {
  const circles = [...Array(4)].map((_, index) => <div key={index} style={{ background: `${color}` }} />)

  return (
    <div className={classNames(styles['lds-ellipsis'], className)} style={{ ...style, width: size, height: size }}>
      {circles}
    </div>
  )
}

Ellipsis.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
  size: PropTypes.number, /** size in pixel */
}

Ellipsis.defaultProps = {
  color: '#7f58af',
  size: 80,
  className: '',
  style: {},
}



// ROLLER
//
export function Roller({ color, className, style }) {
  const circles = [...Array(8)].map((_, index) => {
    return (
      <div key={index}>
        <div className={classNames(styles['div-after'])} style={{ background: color }}></div>
      </div>
    )
  })

  return (
    <div className={classNames(styles['lds-roller'], className)} style={{ ...style }}>
      {circles}
    </div>
  )
}

Roller.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
}

Roller.defaultProps = {
  color: '#7f58af',
  className: '',
  style: {},
}


// MERGE DOTS  <<< NEED FIXING
// ***** REALLY COOL
// src: https://icons8.com/cssload/
export function MergeDots({ color, size, className, style }) {

  return (
    <React.Fragment>
      <div className={classNames(styles['cssload-dots'], className)} style={{ ...style }}>
        <div className={classNames(styles['cssload-dots'], className)} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-dots'], className)} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-dots'], className)} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-dots'], className)} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-dots'], className)} style={{ ...style }}></div>
      </div>

      <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="12" ></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0	0 1 0 0 0	0 0 1 0 0	0 0 0 18 -7" result="goo" ></feColorMatrix>
          </filter>
        </defs>
      </svg>

    </React.Fragment>

  )
}

MergeDots.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
}

MergeDots.defaultProps = {
  color: '#7f58af',
  className: '',
  style: {},
}



// CUBE  <<< ALMOST WORKING, NEED FIXING
// src: https://icons8.com/cssload/
//
export function Cube({ color, size, className, style }) {

      console.log("167: cssload-cube=",styles['.cssload-c1']);
  return (
    <React.Fragment>
      <div className={classNames(styles['cssload-thecube'], className)} style={{ ...style }}>
        <div className={classNames(styles['cssload-cube'])} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-c1'])} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-c2'])} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-c3'])} style={{ ...style }}></div>
        <div className={classNames(styles['cssload-c4'])} style={{ ...style }}></div>
      </div>
    </React.Fragment>
  )
}

Cube.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
}

Cube.defaultProps = {
  color: '#7f58af',
  className: '',
  style: {},
}





// WRAP   << VERY COOL, WORKS
// src: https://icons8.com/cssload/
//
export function Wrap({ color, size, className, style }) {

  return (
    <React.Fragment>
      <div className={classNames(styles['cssload-wrap'], className)} style={{ ...style }}>
        <div className={classNames(styles['cssload-cssload-spinner'], className)} style={{ ...style }}> </div>
      </div>
    </React.Fragment>
  )
}

Wrap.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
}

Wrap.defaultProps = {
  color: '#7f58af',
  className: '',
  style: {},
}






// 3-Bars  
// src:https://projects.lukehaas.me/css-loaders/ 
//
export function LoadingBars({ color, size, className0, style }) {

  // Apply variable params to CSS
  const bars_style = makeStyles((theme) => ({
      loaderBars: {
        color: color,
        background: color,
        fontSize: size,
        "&::before": {
          backgroundColor: color,
        },
        "&::after": {
          backgroundColor: color,
        },
      },
      wrapper: {
        display: 'flex',
        height: 'auto',
      }
  }))
  const bar_class = bars_style()

  return (
    <React.Fragment>
        <div className={classNames(bar_class.wrapper)} style={{ ...style }}>
          <div className={classNames(bar_class.loaderBars, styles['loader-bars'])} style={{ ...style }} /> 
        </div>
    </React.Fragment>
  )
}

LoadingBars.propTypes = {
  color: PropTypes.string, /** hex color */
  className: PropTypes.string, /** class name  */
  style: PropTypes.object, /** style object */
}

LoadingBars.defaultProps = {
  color: '#7f58af',
  className: '',
  style: {},
}






